import(/* webpackMode: "eager" */ "/app/app/lending/page.tsx");
